import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { Home } from './pages/Home'
import { SurveyPage } from './pages/SurveyPage'
import { ThankYou } from './pages/ThankYou'
import { NotFound } from './pages/NotFound'
import { AdminLogin } from './pages/AdminLogin'
import { AdminDashboard } from './pages/AdminDashboard'
import { SurveyBuilder } from './pages/SurveyBuilder'
import { AdminRoute } from './components/AdminRoute'
import 'survey-core/survey-core.min.css'
import './styles/global.css'

export function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/survey/:surveyId" element={<SurveyPage />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/builder"
          element={
            <AdminRoute>
              <SurveyBuilder />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/builder/:surveyId"
          element={
            <AdminRoute>
              <SurveyBuilder />
            </AdminRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  )
}
